import { getDefaultProvider as getDefaultEthersProvider, providers as ethersProviders, } from 'ethers';
import { ConnectorJson, ErrorInvalidConnector, ErrorInvalidEthereum, ipfsResolver, } from '@1hive/connect-core';
import ConnectorEthereum from '@1hive/connect-ethereum';
import ConnectorTheGraph from '@1hive/connect-thegraph';
import { DEFAULT_IPFS_CACHED_ITEMS, DEFAULT_IPFS_URL, XDAI_WSS_ENDPOINT, } from './constants';
export function isIpfsResolver(ipfs) {
    var _a, _b;
    return (typeof ((_a = ipfs) === null || _a === void 0 ? void 0 : _a.url) === 'function' &&
        typeof ((_b = ipfs) === null || _b === void 0 ? void 0 : _b.json) === 'function');
}
export function normalizeIpfsResolver(ipfs) {
    var _a, _b, _c, _d;
    if (isIpfsResolver(ipfs)) {
        return ipfs;
    }
    if (typeof ipfs === 'string') {
        return ipfsResolver(ipfs, DEFAULT_IPFS_CACHED_ITEMS);
    }
    return ipfsResolver((_b = (_a = ipfs) === null || _a === void 0 ? void 0 : _a.urlTemplate) !== null && _b !== void 0 ? _b : DEFAULT_IPFS_URL, (_d = (_c = ipfs) === null || _c === void 0 ? void 0 : _c.cache) !== null && _d !== void 0 ? _d : DEFAULT_IPFS_CACHED_ITEMS);
}
export function normalizeConnectorConfig(connector) {
    if (Array.isArray(connector)) {
        return [connector[0], connector[1] || {}];
    }
    if (typeof connector === 'string') {
        return [connector, {}];
    }
    return null;
}
export function normalizeConnector(connector, network) {
    const normalizedConfig = normalizeConnectorConfig(connector);
    if (normalizedConfig === null) {
        return connector;
    }
    const [name, config] = normalizedConfig;
    if (!config.network) {
        config.network = network;
    }
    if (name === 'json') {
        return new ConnectorJson(config);
    }
    if (name === 'thegraph') {
        return new ConnectorTheGraph(config);
    }
    if (name === 'ethereum') {
        return new ConnectorEthereum(config);
    }
    throw new ErrorInvalidConnector(`Invalid connector: ${name}`);
}
export function normalizeEthersProvider(ethereumProvider, network) {
    // Ethers compatibility: ethereum => homestead
    if (network.name === 'ethereum' && network.chainId === 1) {
        network = { ...network, name: 'homestead' };
    }
    if (ethereumProvider) {
        try {
            return new ethersProviders.Web3Provider(ethereumProvider, network);
        }
        catch (err) {
            console.error('Invalid provider:', ethereumProvider, err);
            throw new ErrorInvalidEthereum('The Ethereum provider doesn’t seem to be valid.');
        }
    }
    if (network.chainId === 100) {
        return new ethersProviders.WebSocketProvider(XDAI_WSS_ENDPOINT, network);
    }
    return getDefaultEthersProvider(network);
}
//# sourceMappingURL=normalizers.js.map